// Home, Landing Pages, About, FAQ, Reviews, Etc.

var availableTags = [
    "alabama",
    "alaska",
    "arizona",
    "arkansas",
    "california",
    "colorado",
    "connecticut",
    "delaware",
    "florida",
    "georgia",
    "hawaii",
    "idaho",
    "illinois",
    "indiana",
    "iowa",
    "kansas",
    "kentucky",
    "louisiana",
    "maine",
    "montana",
    "nebraska",
    "nevada",
    "new hampshire",
    "new jersey",
    "new mexico",
    "new york",
    "north carolina",
    "north dakota",
    "ohio",
    "oklahoma",
    "oregon",
    "maryland",
    "massachusetts",
    "michigan",
    "minnesota",
    "mississippi",
    "missouri",
    "pennsylvania",
    "rhode island",
    "south carolina",
    "south dakota",
    "tennessee",
    "texas",
    "utah",
    "vermont",
    "virginia",
    "washington",
    "west virginia",
    "wisconsin",
    "wyoming",
    "district of columbia"
];

$(document).ready(function () {
    var parts = location.hostname.split('.');
    var subdomain = parts.shift();
    var domestic_violence = false;

    switch (page_info.template) {
        /* HOME LANDING PAGE - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */

        case 'home':

            var count = 0;

            var words = [
                'joy',
                'intimacy',
                'companionship',
                'trust',
                'passion',
                'communication',
                'friendship',
                'affection'
            ];

            var textRotator = setInterval(function () {
                $(".text-rotator").fadeOut(function () {
                    $(".text-rotator").html(words[count]);
                    $(".text-rotator").fadeIn();
                });

                count++;

                if (count == words.length) {
                    count = 0;
                }

            }, 1500);

            break;

        case 'start':

            // Go to second slide
            $("label.btn > input").on("click", function () {
                $("#step-1").hide();
                $("#step-2").show();
            });

            // Go to third slide
            $("#to-step-3").on("click", function () {
                $("#step-2").hide();
                $("#referrer-counselor").hide();
                $("#step-3").show();

                document.body.scrollTop = document.documentElement.scrollTop = 0;
            });
            if ($("#skip-to-three").length) {
                $("#step-3").show();
            }

            var countrySelect = $('#country');
            var stateSelect = $('#state');

            function countryStateLogic() {
                var l = $("#preferred_language");

                if (countrySelect.val() != 1) {
                    $('#state-question').hide(400);
                    if (l.length ) {
                        if (!$.isEmptyObject(page_info['intl_languages'])) {
                            var option;
                            l.empty();
                            for (lang_name in page_info['intl_languages']) {
                                option = $('<option data-testid="questionnaire-dropdown-option"></option>').attr("value", page_info['intl_languages'][lang_name]["lang_id"]).text(page_info['intl_languages'][lang_name]["lang_name"]);
                                l.append(option);
                            }
                            $('#preferred_language-question').show(400);
                        } else {
                            $(l).val(0);
                            $('#preferred_language-question').hide(400);
                        }
                    }
                } else {
                    stateLogic();
                    $('#state-question').show(400);
                }
            }

            countryStateLogic();

            countrySelect.bind('change', function () {
                countryStateLogic();
            });

            function stateLogic() {
                var l = $("#preferred_language");
                var state_id = $(stateSelect).val();

                if ( stateSelect.length &&
                    l.length &&
                    page_info.hasOwnProperty('state_languages') &&
                    page_info['state_languages'].hasOwnProperty(state_id) &&
                    page_info['state_languages'][state_id].length > 1
                ) {
                    var option;
                    $(l).empty();
                    for (lang_info in page_info['state_languages'][state_id]) {
                        option = $('<option></option>').attr("value", page_info['state_languages'][state_id][lang_info]["lang_id"]).text(page_info['state_languages'][state_id][lang_info]["lang_name"]);
                        $(l).append(option);
                    }
                    $('#preferred_language-question').show(400);
                } else {
                    if ($('#country').val() == 1) {
                        $(l).val(0);
                        $('#preferred_language-question').hide(400);
                    } else {
                        $('#preferred_language-question').show(400);
                    }
                }
            }

            stateLogic();

            stateSelect.bind('change', function () {
                stateLogic();
            });

            if (page_info.show_podcast_question) {
                if ($('#podcast option:selected').text() != 'Select podcast' && $('#podcast option:selected').text() != 'Select radio show') {
                    $('#select-podcast').removeClass('hidden');
                    $('#podcast').attr('required', true);
                }
                $('input[type="radio"]').on('click change', function (e) {
                    if (page_info.specify_podcast && $(this).closest('.start-step').is('#step-3') && $(this).closest('.form-group').find('.questionnaire-content-label').html().indexOf("referred you to") > -1) {
                        const referrer_dropdown = {
                            "podcast": {
                                "specify": 'specify_podcast',
                                "aff_list": 'podcast_list',
                                "question": 'Which podcast?',
                                "placeholder": 'Select podcast'
                            },
                            "radio": {
                                "specify": 'specify_radio',
                                "aff_list": 'radio_affiliate_list',
                                "question": 'Which radio show?',
                                "placeholder": 'Select radio show'
                            },
                            "magazine or newspaper": {
                                "specify": 'specify_print',
                                "aff_list": 'print_affiliate_list',
                                "question": 'Which magazine or newspaper?',
                                "placeholder": 'Select magazine or newspaper'
                            },
                            "youtube": {
                                "specify": 'specify_youtube',
                                "aff_list": 'youtube_affiliate_list',
                                "question": 'Which YouTube channel?',
                                "placeholder": 'Select YouTube channel'
                            },
                            "virtual or in-person event": {
                                "specify": 'specify_event',
                                "aff_list": 'event_affiliate_list',
                                "question": 'Which event?',
                                "placeholder": 'Select event'
                            },
                            "celebrity": {
                                "specify": 'specify_celebrity',
                                "aff_list": 'celebrity_affiliate_list',
                                "question": 'Which celebrity?',
                                "placeholder": 'Select celebrity'
                            },
                            "tv": {
                                "specify": 'specify_tv',
                                "aff_list": 'tv_affiliate_list',
                                "question": 'Where on TV?',
                                "placeholder": 'Select where on TV'
                            },
                            "credit card program": {
                                "specify": 'specify_creditcard',
                                "aff_list": 'creditcard_affiliate_list',
                                "question": 'Which credit card program?',
                                "placeholder": 'Select which credit card program'
                            },
                            "streaming radio (pandora, iheart...)": {
                                "specify": 'specify_streaming_radio',
                                "aff_list": 'streaming_radio_affiliate_list',
                                "question": 'Which streaming radio platform?',
                                "placeholder": 'Select streaming radio platform'
                            },
                        }

                        let selected_channel = $.trim($(this).parent().text()).toLowerCase();

                        let has_dropdown = false;
                        if (selected_channel in referrer_dropdown) {
                            var specify = referrer_dropdown[selected_channel]['specify'];
                            has_dropdown = true;
                        }

                        if (
                            has_dropdown
                            && page_info[specify]
                        ) {
                            let placeholder = referrer_dropdown[selected_channel]['placeholder'];
                            let aff_list = referrer_dropdown[selected_channel]['aff_list'];
                            let question = referrer_dropdown[selected_channel]['question'];
                            let idr_text = 'I don\'t remember';
                            if (selected_channel == 'tv' || selected_channel == 'credit card program') {
                                idr_text = 'I don\'t remember/Not listed';
                            }

                            $('#select-podcast').removeClass('hidden');
                            $('#podcast').attr('required', true);

                            $('#select-podcast strong').text(question);
                            $('#podcast').empty();
                            $('#podcast').append('<option value="">' + placeholder + '</option>');
                            $(page_info[aff_list]).each(function (key, value) {
                                $('#podcast').append('<option value="' + value.id + '">' + escape_html(value.podcast_name) + '</option>');
                            });
                            $('#podcast').append('<option data-divider="true"></option><option value="' + page_info.dont_remember_id + '">' + idr_text + '</option>');
                            $('#podcast').selectpicker('refresh');
                        } else {
                            $('#select-podcast').addClass('hidden');
                            $('#podcast').attr('required', false);
                        }
                    }
                });
            }
            break;

        case 'partner':
            $("input[name=invite_partner]:radio").change(function () {
                if (this.value == "no") {
                    $("#partner-info").hide();
                } else {
                    $("#partner-info").show();
                }
            });

            $('#do_this_later').click(function () {
                $("#invite_yes").prop('checked', false);
                $("#invite_no").prop('checked', true);
                $("#partner-info").hide();
                $("#partner_email").val('');
                $("#partner_phone").val('');
                $('#partner_invite_error_partner_email_phone').hide(500);
                $('#partner_invite_error_partner_phone').hide(500);
                $('#partner_invite_error_partner_email').hide(500);
            });

            $('#not_now').click(function () {
                $("#partner_name").val('');
                $("#partner_email").val('');
                $("#partner_phone").val('');
                $('.alert').hide(500);

                $("#action").val('not_now');
            });

            $('#partner_text_invitation').click(function () {
                if ($(this).is(":checked")) {
                    $('#partner_phone_container').removeClass('hide');
                } else {
                    $('#partner_phone_container').addClass('hide');
                }
            });
        break;

        case 'smart_match':
            $('.show_expertise').click(function () {
                $('#expertise1').addClass('hide');
                $('#expertise2').removeClass('hide');
            });
            break;
    }

    if ($('#pin_q_state').length) {
        $("#pin_q_state").autocomplete({
            source: availableTags,
            messages: {
                noResults: '',
                results: ''
            }
        });
    }

    $('#start-form').submit(function () {
        var ret_val = true;
        $('#q_type_error_age').remove();
        $('#q_type_error_state').remove();
        if ($('#pin_q_age').length) {
            if ((!isInt(+$('input#pin_q_age').val()) || +$('input#pin_q_age').val() < 13 || +$('input#pin_q_age').val() > 99)) {
                $('<div id="q_type_error_age" class="alert alert-danger">Please enter an integer between 13 and 99</div>').insertBefore('#pin_q_age');
                ret_val = false;
            }
        }
        if ($('#pin_q_state').length) {
            var state = $.inArray($.trim($('input#pin_q_state').val().toLowerCase()), availableTags);
            if (state < 0) {
                $('<div id="q_type_error_state" class="alert alert-danger">Please enter a valid state</div>').insertBefore('#pin_q_state');
                ret_val = false;
            } else if (ret_val) {
                $('input#pin_q_state').val(state + 1);
            }
        }
        return ret_val;
    });

    if ($('#start-password').length) {
        $('#start-password').password_strength();
    }

    if (window.location.hash === "#voucher-added") {
        $('#modal-voucher-added').modal('show');
    }

   // Infographic logic
    $("#start-form").on("click", function () {
        if ( $("#step-1").css("display") === "block" ) {
            $("#infographic, #infographic-carousel").show();
        } else {
            $("#infographic, #infographic-carousel").hide();
        }
    });

    function get_active_tab() {
        var active_tab;
        $(".carousel-indicators li").each(function (i,e) {
            if ($(e).hasClass("active")) {
                active_tab = parseInt(i, 10);
            }
        });
        return active_tab;
    }

    if (!!page_info['get_t_att']) {
        var get_att_from_url = "https://www.betterhelp.com";
        if (page_info.is_development_local) {
            get_att_from_url = "https://www.betterhelp.com.local";
        }
        get_att_from_url += "/api/get_t_att";
        $.ajax(
            {
                url: get_att_from_url,
                type: "GET",
                xhrFields: { withCredentials: true },
                data: {client_id: page_info['client_id']}
            }
        )
            .done(function (data) {
                var result = JSON.parse(data);
                set_cookie('t_att', result['cookie_value'], 365 * 60 * 60);
            })
    }

    var left_chevron = $(".fa-chevron-left ");
    var left_chevron_anchor_element = $(".left");
    var right_chevron = $(".fa-chevron-right ");
    var right_chevron_anchor_element = $(".right");

    $("#infographic-carousel").on("click", function () {
        setTimeout(function () {
            if (get_active_tab() === 0) {
                right_chevron_anchor_element.removeClass("hidden");
                left_chevron_anchor_element.addClass("hidden");
            } else if (get_active_tab() > 0 && get_active_tab() < 2) {
                left_chevron_anchor_element.removeClass("hidden");
                right_chevron_anchor_element.removeClass("hidden");
            } else {
                left_chevron_anchor_element.removeClass("hidden");
                right_chevron_anchor_element.addClass("hidden");
            }
            // To restart animations in sync after user click (2-part process: 2nd part)
            pause_animations();
        }, 50);
        // To restart animations in sync after user click (2-part process: 1st part)
        pause_animations();
    });

    $(".carousel-control").on("click", function () {
        $("#infographic-carousel").trigger("click");
    });

    function pause_animations() {
        // Using 'toggleClass' results in buggy behaviour, with elements not being animated appropriately
        right_chevron.removeClass("animation-pulse");
        left_chevron.removeClass("animation-pulse");
        setTimeout(function () {
            right_chevron.addClass("animation-pulse");
            left_chevron.addClass("animation-pulse");
        }, 50);
    }

    right_chevron.hover(function () {
        pause_animations();
    });

    left_chevron.hover(function () {
        pause_animations();
    });

    $(".carousel").on("touchstart", function (event) {
        var xClick = event.originalEvent.touches[0].pageX;
        $(".carousel").one("touchmove", function (event) {
            var xMove = event.originalEvent.touches[0].pageX;
            if ( (get_active_tab() >= 0 && get_active_tab() < 2) && Math.floor(xClick - xMove) > 0 ) {
                $(this).carousel('next');
            } else if ( (get_active_tab() > 0 && get_active_tab() <= 2) && Math.floor(xClick - xMove) < -2 ) {
                $(this).carousel('prev');
            }
        });
        $(".carousel").on("touchend", function () {
            $(this).off("touchmove");
            $("#infographic-carousel").trigger("click"); // Hack, to update infographic logic
        });
    });

    if (page_info.openbucks_added) {
        $('#modal-openbucks-added').modal('show');
    }
    function focus_on_signup_error_input() {
        $('#step-4 input').removeAttr('aria-describedby');

        if ($('#signup-error-alert').html().indexOf('Please agree to the terms and conditions') > -1) {
            $('#start-agree').attr('aria-describedby', 'signup-error-alert').focus();
        } else {
            $('#step-4 .has-error input').first().attr('aria-describedby', 'signup-error-alert').focus();
        }
    }

    if ($('#step-4 #signup').length) {
        focus_on_signup_error_input();
    }

    if (!!page_info.skip_who_referred_question) {
        var referred_answers = $('.referred_you');
        referred_answers.closest('.question').addClass('hidden');
        referred_answers.find('input').attr('required', false);
    } else {
        $('.referred_you').on('change', function () {
            if ($(this).hasClass('other_radio')) {
                $('#other_text_box_wrapper').removeClass('hidden');
                $('#other_text_box').attr('required', true);
            } else {
                $('#other_text_box_wrapper').addClass('hidden');
                $('#other_text_box').attr('required', false);
                $('#other_text_box').val('');
            }
        });
    }

    $('.finance').on('change', function () {
        if ($(this).hasClass('good_finance')) {
            $('#insurance_income').addClass('hidden');
            $('#insurance-question').addClass('hidden');
            $('#additional_income').addClass('hidden');
            $('#annual_income').val('');
            $('#annual_income').attr('disabled', true);
            $('#household_size').val('');
            $('#household_size').attr('disabled', true);
            $('#insurance_income input:checkbox').removeAttr('checked');
        } else {
            $('#insurance_income').removeClass('hidden');
            $('#insurance-question').removeClass('hidden');
            $('#annual_income').attr('disabled', false);
            $('#household_size').attr('disabled', false);
        }
    });

    $('#insurance_income').on('change', function (event) {
        checkbox = $.trim($(event.target).parent().text()).toLowerCase();
        if (checkbox === "i'm employed but my income is low") {
            $('#additional_income').toggleClass('hidden');
            if ($('#additional_income').hasClass('hidden')) {
                $('#annual_income').val('');
                $('#annual_income').attr('disabled', true);
                $('#household_size').val('');
                $('#household_size').attr('disabled', true);
            } else {
                $('#annual_income').attr('disabled', false);
                $('#household_size').attr('disabled', false);
            }
        }
    });

    $('#annual_income').keyup(function (event) {
        //prevent user from entering non-numeric characters
        if (event.which >= 37 && event.which <= 40) {
            return;
        }
        $(this).val(function (index, value) {
            return value
                .replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                ;
        });
    });

});
